
<template>
    <section id="content">
        <div class="content-wrap">
            <div class="container">
            </div>
            <section v-if="obj.typeId == 2" id="page-title">

                <div class="container clearfix">
                    <h1>{{$t("InterestedPartner-TrainingCenter")}}</h1>
                </div>

            </section>
            <section v-if="obj.typeId == 1" id="page-title">

                <div class="container clearfix">
                    <h1>{{$t("InterestedPartner-Employer")}}</h1>
                </div>

            </section>
            <!-- #page-title end -->
            <section id="content">
                <div class="container clearfix">
                    <div class="row col-mb-50">
                        <div class="col-lg-12">
                            <h3>  {{$t("InterestedPartner-ContactUsTitle")}} </h3>
                            <div class="form-widget">
                                <form class="mb-0" name="template-contactform" action="#" method="post">
                                    <div class="row">
                                        <div class="col-md-6 form-group">
                                            <label>{{$t("InterestedPartner-EntityName")}}<small>*</small></label>
                                            <input type="text" v-model.trim="obj.entityName" :placeholder='$t("InterestedPartner-EntityName")'
                                                   class="form-control" :class="{ 'is-invalid':v$.obj.entityName?.$invalid && submitted}" />
                                            <span v-if="v$.entityName?.$error && submitted">
                                                <span id="entityName-error" v-for="(error, index) of v$.obj.entityName?.$errors" :key="index">
                                                    <small class="invalid-feedback">{{error.$message}}</small>
                                                </span>
                                            </span>
                                            <small v-else-if="(v$.obj.entityName?.$invalid && submitted) || v$.obj.entityName?.$pending.$response" class="invalid-feedback">{{$t("InterestedPartner-EntityNameValidationMsg")}}</small>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3 form-group">
                                            <label>{{$t("InterestedPartner-AdminName")}}<small>*</small></label>
                                            <input type="text" v-model.trim="obj.adminName" :placeholder='$t("InterestedPartner-AdminName")'
                                                   class="form-control" :class="{ 'is-invalid':v$.obj.adminName?.$invalid && submitted}" />
                                            <span v-if="v$.adminName?.$error && submitted">
                                                <span id="adminName-error" v-for="(error, index) of v$.obj.adminName?.$errors" :key="index">
                                                    <small class="invalid-feedback">{{error.$message}}</small>
                                                </span>
                                            </span>
                                            <small v-else-if="(v$.obj.adminName?.$invalid && submitted) || v$.obj.adminName?.$pending.$response" class="invalid-feedback">{{$t("InterestedPartner-AdminNameValidationMsg")}}</small>
                                        </div>
                                        <div class="col-md-3 form-group">
                                            <label>{{$t("InterestedPartner-Email")}}<small>*</small></label>
                                            <input v-model.trim="obj.email" type="text" class="form-control" :placeholder='$t("InterestedPartner-Email")' :class="{ 'is-invalid':(v$.obj.email?.$invalid || v$.obj.email.required?.$invalid )  && submitted}">
                                            <small class="invalid-feedback" v-if="(v$.obj.email?.required?.$invalid && submitted)">{{$t("InterestedPartner-EmailValidationMsg")}}</small>
                                            <small class="invalid-feedback" v-else-if="(v$.obj.email?.$invalid && submitted)">{{$t("InterestedPartner-EmailInvalidErrorMsg")}}</small>
                                        </div>
                                        <div class="col-md-3 form-group">
                                            <label>{{$t("InterestedPartner-PhoneNumber")}}<small>*</small></label>
                                            <input v-model.trim="obj.phoneNumber" type="text" class="form-control" placeholder="05xxxxxxxx" :class="{ 'is-invalid':(v$.obj.phoneNumber?.$invalid || v$.obj.phoneNumber.required?.$invalid )  && submitted}">
                                            <small class="invalid-feedback" v-if="(v$.obj.phoneNumber.required?.$invalid && submitted)">{{$t("InterestedPartner-PhoneValidationMsg")}}</small>
                                            <small class="invalid-feedback" v-else-if="(v$.obj.phoneNumber?.$invalid && submitted)">{{$t("InterestedPartner-PhoneNumberInvalidErrorMsg")}}</small>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 form-group">
                                            <label>{{$t("InterestedPartner-Programs")}} <small>*</small></label>
                                            <select v-model="obj.programIds" multiple class="selectpicker" :class="{ 'is-invalid':v$.obj.programIds?.$invalid && submitted}">
                                                <option v-for="program in obj.ProgramsOptions" :value="program.id">{{program.text}}</option>
                                            </select>
                                            <small class="invalid-feedback" style="display:block" v-if="(v$.obj.programIds?.$invalid && submitted) || v$.obj.programIds?.$pending.$response">{{$t("InterestedPartner-ProgramsValidationMsg")}}</small>
                                        </div>
                                    </div>
                                    <div class="mb-2">
                                        <div>
                                            <input id="cbIsApplyNewPrograms" v-model="obj.isApplyNewPrograms" class="checkbox-style" name="checkbox-12"
                                                   type="checkbox">
                                            <label for="cbIsApplyNewPrograms" class="checkbox-style-3-label">
                                                {{$t("InterestedPartner-IsApplyNewPrograms")}}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group" id="other-programs" v-if="obj.isApplyNewPrograms">
                                        <label> {{$t("InterestedPartner-NewProgramsDetails")}}</label>
                                        <textarea class="form-control" :class="{ 'is-invalid': newProgramDetailsNotValid && submitted}" v-model="obj.newProgramDetails" rows="3"></textarea>
                                        <small class="invalid-feedback" v-if="newProgramDetailsNotValid && submitted">{{$t("InterestedPartner-NewProgramDetailsNotValidMsg")}}</small>
                                    </div>
                                    <div class="mb-4" v-if="obj.typeId == 2">
                                        <div>
                                            <input id="cbIsInterestedEmployment" v-model="obj.isInterestedEmployment" class="checkbox-style" name="checkbox-10"
                                                   type="checkbox">
                                            <label for="cbIsInterestedEmployment" class="checkbox-style-3-label">
                                                {{$t("InterestedPartner-IsInterestedEmployment")}}
                                            </label>
                                        </div>
                                        <router-link id="employer-info" target="_blank" v-if="obj.isInterestedEmployment" :to="{name:'ProgramsTypePage', params:{typeId:3 ,id:obj.programId}}" class="text-decoration-underline">
                                            <i class="fa-solid fa-briefcase me-2"></i>
                                            {{$t("InterestedPartner-ViewEmploymentDetails")}}
                                        </router-link>
                                    </div>
                                    <div class="mb-4" v-else-if="obj.typeId == 3">
                                        <div>
                                            <input id="cbIsInterestedTraining" v-model="obj.isInterestedTraining" class="checkbox-style" name="checkbox-10"
                                                   type="checkbox">
                                            <label for="cbIsInterestedTraining" class="checkbox-style-3-label">
                                                {{$t("InterestedPartner-IsInterestedTraining")}}
                                            </label>
                                        </div>
                                        <router-link id="training-info" target="_blank" v-if="obj.isInterestedTraining" :to="{name:'ProgramsTypePage', params:{typeId:2 ,id:obj.programId}}" class="text-decoration-underline">
                                            <i class="fa-solid fa-briefcase me-2"></i>
                                            {{$t("InterestedPartner-ViewTrainingCenterDetails")}}
                                        </router-link>
                                    </div>
                                    <div class="form-group">
                                        <button type="button" class="button button-3d m-0" @click="handleSubmit(!v$.$invalid)">
                                            {{$t("InterestedPartner-Send")}}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>


                </div>
            </section>

        </div>
    </section><!-- #content end -->
</template>


<script>
    import { data } from "./Data/InterestedPartnerData.js"
    import * as interestedPartnerService from './Service/InterestedPartnerService'
    import { useVuelidate } from "@vuelidate/core";
    import { required, maxLength, minLength, email, numeric } from "@vuelidate/validators";
    export default {
        name: 'InterestedPartnerComponent',
        setup: () => ({ v$: useVuelidate() }),
        data: function () {
            return data
        },
        validations() {
            return {
                obj: {
                    entityName: {
                        required
                    },
                    adminName: {
                        required
                    },
                    email: {
                        required, email
                    },
                    phoneNumber: {
                        required, min: minLength(10), max: maxLength(10), numeric
                    },
                    programIds: {
                        required
                    }
                }
            }
        },
        async created() {
            var programId = this.$route.params.id;
            this.obj.programId = programId;
            this.obj.programIds = [programId];
            this.obj.typeId = this.$route.params.typeId;
            await this.getProgramOptions();
        },
        mounted() {
            //this.$nextTick(function () {
            //    $('.selectpicker').selectpicker('refresh').trigger('change');
            //});
        },
        methods: {
            async getProgramOptions() {
                await interestedPartnerService.GetProgramOptions(this);
            },
            saveInterestedPartner() {
                interestedPartnerService.SaveInterestedPartner(this);
            },
            async handleSubmit(isFormValid) {
                this.submitted = true;
                this.newProgramDetailsNotValid = this.obj.isApplyNewPrograms && !this.obj.newProgramDetails;
                if (!isFormValid || this.newProgramDetailsNotValid) {
                    return;
                }
                this.saveInterestedPartner();
            }
        }
    }

</script>